import(/* webpackMode: "eager" */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
import(/* webpackMode: "eager" */ "/app/src/components/InquryForm/ContactForm.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/Blog.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/CommonProductShowCase.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/EbooksLibrary.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/EnterpriseNews.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/GetQuteTip.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/IndustryNews.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/PageList.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/ProductKnowledge.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/Resource/ResourceBanner.tsx")